-<template>
	<v-container>
		<PageTitle icon="mdi-account-group" main="Colaboradores" sub=""/>
		<DialogUser :data="usuarios" :modo="mode" />
		
		<!-- Painel de Controle -->
		<v-card flat class="background mb-4">
			<v-card-text class="pa-4">
				<v-row align="center">
					<v-col cols="12" md="6">
						<div class="d-flex align-center">
							<div class="mr-6">
								<div class="text-h6 font-weight-regular">{{ usuarios.length }}</div>
								<div class="text-caption secondary--text text--lighten-1">Total de Colaboradores</div>
							</div>
							<v-divider vertical class="mx-4"></v-divider>
							<div>
								<div class="text-h6 font-weight-regular">{{ usuarios.filter(u => u.status).length }}</div>
								<div class="text-caption secondary--text text--lighten-1">Ativos</div>
							</div>
						</div>
					</v-col>
					<v-col cols="12" md="6">
						<v-text-field 
						v-model="busca" 
						append-icon="mdi-magnify" 
						label="Buscar colaborador" 
						single-line 
						hide-details
						outlined
						dense
						></v-text-field>
					</v-col>
				</v-row>
			</v-card-text>
		</v-card>

		<!-- Tabela de Colaboradores -->
		<v-card flat>
			<v-card-title class="secondary--text font-weight-regular pb-2">
				Lista de Colaboradores
			</v-card-title>
			<v-divider></v-divider>
			<v-data-table 
			:headers="table" 
			:items="usuarios"
			:items-per-page="-1"
			:search="busca"
			hide-default-footer
			class="elevation-0"
			>
			<template v-slot:item="{ item }">
				<tr>
					<td class="text-caption">{{ item.idfuncionarios }}</td>
					<td>
						<div class="font-weight-medium">{{ item.nome }}</div>
						<div class="text-caption secondary--text text--lighten-1">{{ item.email }}</div>
					</td>
					<td class="text-body-2">{{ item.usuario }}</td>
					<td class="text-body-2">{{ item.cod_pdv || '-' }}</td>
					<td class="text-body-2">{{ item.cod_vendedor || '-' }}</td>
					<td class="text-body-2">{{ item.contato || '-' }}</td>
					<td>
						<v-chip small :color="getRoleColor(item.tipo)" text-color="white">
							{{ item.tipo }}
						</v-chip>
					</td>
					<td>
						<v-btn icon small @click="loadUser(item, 'save')">
							<v-icon small color="primary">mdi-pencil</v-icon>
						</v-btn>
						<v-btn 
						icon 
						small 
						@click="loadUser(item, 'remove')" 
						v-if="usuarios.length > 1 && (user.tipo !== item.tipo)"
						>
						<v-icon small color="error">mdi-delete</v-icon>
					</v-btn>
				</td>
			</tr>
		</template>
	</v-data-table>
</v-card>
</v-container>
</template>

<script>
import axios from 'axios'
import { baseApiUrl, showError } from '@/global'
import DialogUser from './DialogUser'
import { mapState } from 'vuex'
import moment from 'moment'
import Bus from '@/barramento'
import PageTitle from '@/templates/PageTitle'	
export default {

	name: 'TheUsuarios',
	components:{ PageTitle, DialogUser },
	data () {
		return {
			mode:'save',
			usuarios:[],
			pontos:[],
			busca:'',
			expanded: [],
			table:[
				{text:'Cod', value:'idfuncionarios'},
				{text:'Nome', value:'nome'},
				{text:'Usuário', value:'usuario'},
				{text:'COD PDV', value:'cod_pdv'},
				{text:'COD Colaborador', value:'cod_vendedor'},
				{text:'Contato', value:'contato'},
				{text:'Função', value:'tipo'},
				{text:'Ações', value:'actions'},
				]
		}
	},
	methods:{
		getRoleColor(tipo) {
			switch(tipo) {
			case 'Master': return 'grey darken-3'
			case 'Admin': return 'grey darken-2'
			case 'Gerente': return 'grey darken-1'
			default: return 'grey'
			}
		},
		async loadUsers() {
			try {
				const res = await axios.get(`${baseApiUrl}/usuarios?status=ativos`)
        // Permissão de acesso é individual; cargo/tipo não filtra mais a lista.
				this.usuarios = res.data || []
			} catch (error) {
				showError(error);
			}
		},
		async loadUser(item, modo = 'save') {
			try{
				Bus.$emit('loadUser', item, modo)
			} catch(e){
				showError(e)
			}
		},
		async loadExpediente(item) {
			try{
				console.log(item)
			} catch(e){
				showError(e)
			}
		},
		loadPontos() {
			axios.get(`${baseApiUrl}/pontos`)
			.then(res => res.data = this.pontos)
			.catch(showError)
		},
		formatoData(data) {
			if (data) {
				return moment(data, "YYYY-MM-DD").format("DD/MM/YYYY");
			}
		},
		formatoHora(data) {
			if (data) {
				return moment(data, "YYYY-MM-DD HH:mm:ss").locale('pt-br').format("HH:mm:ss");
			}
		},
		hoje(data) {
			return moment(data, "YYYY-MM-DD").format("DD/MM/YYYY");
		},
	},
	computed: { ...mapState(['user']) },
	mounted(){
		this.loadUsers()
		Bus.$on('reload',() => {
			this.loadUsers()
		})
	}
}
</script>


<style lang="css" scoped>
</style>